import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from '../store';
import { AuthProvider } from '../context/AuthContext';
import { SensorProvider } from '../modules/monitoring';
import SensorSocketBridge from '../components/socket/SensorSocketBridge';
import CriticalAlertToaster from '../components/notifications/CriticalAlertToaster';
import AppSnackbarProvider from '../components/feedback/AppSnackbarProvider';


export default function AppProviders({ children }) {
  return (
    <Provider store={store}>
      <AppSnackbarProvider>
        <AuthProvider>
          <SensorProvider>
            <SensorSocketBridge />
            <CriticalAlertToaster />
            <BrowserRouter>{children}</BrowserRouter>
          </SensorProvider>
        </AuthProvider>
      </AppSnackbarProvider>
    </Provider>
  );
}
